import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import WinnerDropBadge from "../winner/WinnerDropBadge";
import WaveDropTime from "../time/WaveDropTime";
interface ParticipationDropHeaderProps {
  readonly drop: ExtendedDrop;
  readonly showWaveInfo: boolean;
}
export default function ParticipationDropHeader(t0) {
  const $ = _c(22);
  const {
    drop,
    showWaveInfo
  } = t0;
  const t1 = `/${drop.author.handle}`;
  let t2;
  if ($[0] !== drop.author.handle || $[1] !== t1) {
    t2 = <p className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold"><Link onClick={_temp} href={t1} className="tw-no-underline tw-text-iron-200 hover:tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out">{drop.author.handle}</Link></p>;
    $[0] = drop.author.handle;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== drop.author.level) {
    t3 = <UserCICAndLevel level={drop.author.level} size={UserCICAndLevelSize.SMALL} />;
    $[3] = drop.author.level;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== drop.rank || $[6] !== drop.winning_context?.decision_time) {
    t4 = drop.rank && <WinnerDropBadge rank={drop.rank} decisionTime={drop.winning_context?.decision_time ?? null} />;
    $[5] = drop.rank;
    $[6] = drop.winning_context?.decision_time;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="tw-size-[3px] tw-bg-iron-600 tw-rounded-full tw-flex-shrink-0" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== drop.created_at) {
    t6 = <WaveDropTime timestamp={drop.created_at} />;
    $[9] = drop.created_at;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t6) {
    t7 = <div className="tw-flex tw-items-center tw-gap-x-2 tw-flex-wrap">{t2}{t3}{t4}{t5}{t6}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== drop.wave || $[17] !== showWaveInfo) {
    t8 = showWaveInfo && drop.wave && (() => {
      const waveMeta = (drop.wave as unknown as {
        chat?: {
          scope?: {
            group?: {
              is_direct_message?: boolean | undefined;
            } | undefined;
          } | undefined;
        } | undefined;
      })?.chat;
      const isDirectMessage = waveMeta?.scope?.group?.is_direct_message ?? false;
      const waveHref = getWaveRoute({
        waveId: drop.wave.id,
        isDirectMessage,
        isApp: false
      });
      return <Link onClick={_temp2} href={waveHref} className="tw-mb-0 tw-text-[11px] tw-leading-0 tw-text-iron-500 hover:tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out tw-no-underline">{drop.wave.name}</Link>;
    })();
    $[16] = drop.wave;
    $[17] = showWaveInfo;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(e) {
  return e.stopPropagation();
}